var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-tree", {
    attrs: {
      props: _vm.defaultProps,
      load: _vm.loadNode,
      data: _vm.rootData,
      "highlight-current": "",
      "expand-on-click-node": false,
      "node-key": "orgId",
      "show-checkbox": _vm.multiple,
      "current-node-key": _vm.selectId
    },
    on: { "node-click": _vm.handleNodeClick }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }